import { MessageSquare } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

import type { RoadmapPost } from '../api/types'
import { StatusPill } from './StatusPill'
import { VoteButton } from './VoteButton'

export type PostCardProps = {
  post: RoadmapPost
  pendingVote: boolean
  onVote: (postId: string) => void
}

export const PostCard = ({
  post,
  pendingVote,
  onVote,
}: PostCardProps): JSX.Element => {
  const navigate = useNavigate()

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={() => navigate(`/posts/${post.id}`)}
      onKeyDown={(event) => {
        if (event.key === 'Enter') {
          navigate(`/posts/${post.id}`)
        }
      }}
      className="flex cursor-pointer items-start gap-4 rounded-2xl border border-dune-border bg-white p-4 transition-colors hover:border-dune-accent sm:p-5"
    >
      <VoteButton
        voteCount={post.voteCount}
        hasVoted={post.hasVoted}
        pending={pendingVote}
        onVote={() => onVote(post.id)}
      />

      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-center gap-2">
          <h3 className="font-display text-base font-medium text-dune-text sm:text-lg">
            {post.title}
          </h3>

          <StatusPill status={post.status} />
        </div>

        {post.description ? (
          <p className="mt-1.5 line-clamp-2 text-sm text-dune-text-secondary">
            {post.description}
          </p>
        ) : null}

        <div className="mt-3 flex items-center gap-1.5 text-dune-text-secondary">
          <MessageSquare className="h-3.5 w-3.5" />
          <span className="font-display text-xs">
            {post.commentCount}{' '}
            {post.commentCount === 1 ? 'comentário' : 'comentários'}
          </span>
        </div>
      </div>
    </div>
  )
}
